import PropTypes from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, Button, Label, FormGroup, Input } from 'reactstrap';
import Documentos from '../../components/users/Documentos';
import { AuthContext } from '../../context/authContext';
import matriculacionApiService from '../../services/http/matriculacionApiService';
import { getItem, STORAGE_KEYS } from '../../services/storage';
import useSoloLecturaMatriculas from '../../hooks/useSoloLecturaMatriculas';
import logger from '../../services/logger';

const ModalText = (props) => {
  const [comment, setComment] = useState(props.motivoBaja);
  const [motivos, setMotivos] = useState([]); // lista de motivos de baja
  const [selectedMotivo, setSelectedMotivo] = useState(''); // motivo seleccionado

  const enrollmentSession = getItem(STORAGE_KEYS.ENROLLMENT);
  const { userOU } = useContext(AuthContext);
  const soloLectura = useSoloLecturaMatriculas();

  // 🔹 Cargar motivos de baja desde la API al montar el modal
  useEffect(() => {
    const fetchMotivos = async () => {
      try {
        const response = await matriculacionApiService.obtenerMotivoBaja({
          headquarter: enrollmentSession.headquarter,
        });

        setMotivos(response);
      } catch (error) {
        logger.error('Error cargando motivos de baja:', error);
      }
    };
    fetchMotivos();
  }, [enrollmentSession.headquarter]);

  const handleCommentChange = (e) => setComment(e.target.value);
  const handleMotivoChange = (e) => setSelectedMotivo(e.target.value);

  const handleSubmit = async (rechazo) => {
    let estado = 8;

    if (userOU.centro === 'SUPERADMIN' || userOU.centro === 'SECRETARÍA') {
      estado = rechazo ? 1 : 3;
    }

    try {
      await matriculacionApiService.bajaMatricula({
        headquarter: enrollmentSession.headquarter,
        id: enrollmentSession.id,
        motivo: selectedMotivo, // 🔹 Enviamos el motivo seleccionado
        comment,
        nombreCiclo: props.curso,
        estado,
      });

      props.setState(false);
      window.location.reload();
    } catch (error) {
      logger.error('Error al dar de baja:', error);
      props.setState(true);
    }
  };

  const handleOnClose = () => props.setState(false);

  return (
    <div>
      <Modal isOpen={props.state} centered size="lg" zIndex={100}>
        <ModalBody>
          <Label htmlFor="motivoBaja">
            <b>Motivo de baja</b>
          </Label>
          <FormGroup>
            <Input
              type="select"
              id="motivoBaja"
              value={selectedMotivo}
              onChange={handleMotivoChange}
              className="mb-3"
            >
              <option value="">-- Selecciona un motivo --</option>
              {Array.isArray(motivos) &&
                motivos.map((motivo) => (
                  <option key={motivo.codigo} value={motivo.codigo}>
                    {motivo.motivo}
                  </option>
                ))}
            </Input>
          </FormGroup>

          <Label htmlFor="comentarioBaja">
            <b>Comentario de baja</b>
          </Label>
          {props.estadoMatricula === 'Pendiente baja' ? (
            <p>{props.motivoBaja}</p>
          ) : (
            <FormGroup>
              <Input
                type="textarea"
                name="text"
                id="comentarioBaja"
                className="mb-3"
                onChange={handleCommentChange}
              />
              <Documentos datosDocumento={props.doc} />
            </FormGroup>
          )}
        </ModalBody>

        <ModalFooter>
          {props.estadoMatricula === 'Pendiente baja' ? (
            <>
              <Button color="danger" onClick={() => handleSubmit(false)} disabled={soloLectura}>
                Dar de baja
              </Button>
              <Button color="warning" onClick={() => handleSubmit(true)} disabled={soloLectura}>
                Rechazar
              </Button>
            </>
          ) : (
            <Button
              color="danger"
              onClick={() => handleSubmit(false)}
              disabled={!comment || !selectedMotivo || soloLectura}
            >
              {userOU.centro === 'SECRETARÍA' || userOU.centro === 'SUPERADMIN'
                ? 'Dar de baja'
                : 'Solicitar baja'}
            </Button>
          )}
          <Button onClick={handleOnClose}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

ModalText.propTypes = {
  state: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  setState: PropTypes.func,
  estadoMatricula: PropTypes.string,
  motivoBaja: PropTypes.string,
  curso: PropTypes.string,
  doc: PropTypes.object,
};

export default ModalText;
